import axios from 'axios';

let host;
try {
  if (process.env.REACT_APP_PROXY_ENABLED === 'true') {
    host = `${window.location.origin}/`;
  } else {
    host = process.env.REACT_APP_API_HOST;
  }
} catch (e) {
  host = `${window.location.origin}/`;
}

export const API_HOST = host;
export const restClient = axios.create({
  baseURL: API_HOST,
});
